$(() => {
  $(document).ready(function() {
    $("#open-jobs-link").on("click", function(event) {
      event.preventDefault()
      history.replaceState({}, "", "#open-jobs")
      $("html,body").animate({
          scrollTop: $("#open-jobs").offset().top - 20
      }, 1000)
    })
  })
})